module.exports = "/lucky-balls/img/icons/512.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/icons/512.png
// module id = 1062
// module chunks = 0